import { useMutation } from '@tanstack/react-query';
import { TYPE_ERROR } from '../../../../shared/notification/actions';
import { uploadCover, uploadPdf } from './uploadLocalContentProductAsset';
import { AxiosError } from 'axios';
import { invalidateLocalContentProduct } from './useLocalContentProduct';
import { useTranslation } from 'react-i18next';
import { showNotification } from '../../../../shared/notification/toastNotification';

export type UploadProgressCallback = (progress: number) => void;

export interface UploadArgs {
    asset: File;
    uploadProgressCallback: UploadProgressCallback;
}

export const useUploadLocalContentCover = (productId: string) => {
    const { t } = useTranslation();

    return useMutation(
        ({ asset, uploadProgressCallback }: UploadArgs) => uploadCover(asset, productId, uploadProgressCallback),
        {
            onSuccess: () => {
                showNotification(t('notifications.useUploadLocalContentCover.success'));
                invalidateLocalContentProduct(productId).then();
            },
            onError: (error: AxiosError<{ message: string; errorCode?: string }>) => {
                if (error?.response?.data?.errorCode === 'invalidMediaType') {
                    showNotification(error.response.data.message, TYPE_ERROR);
                } else {
                    showNotification(t('notifications.useUploadLocalContentCover.error'), TYPE_ERROR);
                }
            }
        }
    );
};

export const useUploadLocalContentAsset = (productId: string) => {
    const { t } = useTranslation();

    return useMutation(
        ({ asset, uploadProgressCallback }: UploadArgs) => uploadPdf(asset, productId, uploadProgressCallback),
        {
            onSuccess: () => {
                showNotification(t('notifications.useUploadLocalContentAsset.success'));
                invalidateLocalContentProduct(productId).then();
            },
            onError: () => {
                showNotification(t('notifications.useUploadLocalContentAsset.error'), TYPE_ERROR);
            }
        }
    );
};
